import React, { useEffect, useState } from 'react';
import { KTIcon } from '../../../_metronic/helpers';
import { AddReturns } from './AddReturns';
import axios from 'axios';
import { ReturnDetails } from './ReturnDetails';
import Loader from "react-js-loader";
import { UploadReturnImg } from './UploadReturnImg';
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import { Card } from 'primereact/card';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  return JSON.parse(data);
}

const Returns = () => {

  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [showCreateAppModal2, setShowCreateAppModal2] = useState(false);
  const [showCreateAppModal3, setShowCreateAppModal3] = useState(false);

  const [returnsData, setReturnsData] = useState([]);
  // const [returnInput, setReturnInput] = useState("");
  // const [errorMsg, setErrorMsg] = useState("");
  const [detailsData, setDetailsData] = useState({});
  const [loading, setLoading] = useState(false);
  // const [editMode, setEditMode] = useState(null);
  const [refund_code, setRefund_code] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL;
  const GET_RETURNS_DATA = `${API_URL}/get-refund-requests`;
  // const ADD_RETURNS = `${API_URL}/refund-request-create`;
  const apiToken = getLocalData().api_token;
   const isMobileDevice = MobileUse();

  const getReturnsData = async () => {
    setLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${apiToken}` }
    };
    await axios.get(GET_RETURNS_DATA, config)
      .then((response) => {
        setReturnsData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  // const addReturns = async (id) => {
  //   setErrorMsg("");
  //   const data = {
  //     reverse_order: returnInput,
  //     refund_code: id
  //   }
  //   if (!returnInput) {
  //     setErrorMsg("Enter Tracking number");
  //   } else {
  //     await axios.post(ADD_RETURNS, data)
  //       .then((response) => {
  //         console.log(response.data);
  //         getReturnsData();
  //         setEditMode(null)
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   };
  // };

  const statusBody = (item) =>{
    return(
      <>
      {item.status == 0 && (
          <span className='badge badge-light-success fs-8 fw-bold success_active'>Received</span>
      )}
      {item.status == 1 && (
        <span className='badge badge-light-warning fs-8 fw-bold warning_active'>Pending</span>
      )}
      {item.status == 2 && (
        <span className='badge badge-light-info fs-8 fw-bold'>Active</span>
      )}
      {item.status == 3 && (
        <span className='badge badge-light-danger fs-8 fw-bold danger_active'>Expired</span>
      )}
      </>
    )
  }

  const DataViewItem = ({item,idx}) =>{
      return(
        <Card key={idx} className="mb-3" style={{borderBottom:'3px solid red'}}>
            {/* <div className="p-d-flex p-ai-center mb-2"></div> */}
            <div className="row">
              <div className="col-9">
                <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                    {item.tracking_id}
                  </span>
              </div>
              <div className="col-3">
                <span><i
                      onClick={() => {
                        setDetailsData(item);
                        setShowCreateAppModal2(true);
                      }} className="fa-solid fa-circle-info"></i>
                </span>
              </div>
              <div className="col-12">
                <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                  {item.name} ( {item.commit_no} )
                </span>
              </div>
              <div className="col-6">
                <h5 className='mt-5'>{statusBody(item)}</h5>
              </div>
              <div className="col-6">
                <h5 className='mt-5'>{item.date}</h5>
              </div>
            </div>
          </Card>
      )
    }

  useEffect(() => {
    getReturnsData();
  }, []);

  return (
    <div>
      <AddReturns
        show={showCreateAppModal}
        handleClose={() => {
          setShowCreateAppModal(false);
        }}
        getReturnsData={getReturnsData}
      />
      <ReturnDetails
        show={showCreateAppModal2}
        handleClose={() => {
          setShowCreateAppModal2(false);
        }}
        detailsData={detailsData}
      />
      <UploadReturnImg
        show={showCreateAppModal3}
        handleClose={() => {
          setShowCreateAppModal3(false);
        }}
        getReturnsData={getReturnsData}
        refund_code={refund_code}
      />
      
      <div className='card card-body shadow top-rounded'>
        <div className='card-title d-flex justify-content-between align-items-center mt-3'>
            <div className='d-flex align-items-center'>
              <h3 className='m-0 text-gray-800'>Returns</h3>
            </div>
        </div>
        <div className='card-body px-1 py-3'>
          {!isMobileDevice ? (
          <div className='table-responsive'>
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              <thead>
                <tr className='fw-bold' style={{backgroundColor:'#f7f9fa'}}>
                  <th className='min-w-120px'>ID</th>
                  <th className='min-w-120px'>Name</th>
                  <th className='min-w-120px'>Tracking No.</th>
                  <th className='min-w-120px'>Commitment No.</th>
                  <th className='min-w-120px'>Status</th>
                  <th className='min-w-120px'>Date</th>
                </tr>
              </thead>
              {returnsData.length === 0 &&
                <div className='fs-5 fw-semibold text-gray-600'>
                  <p>No Returns Available.</p>
                </div>
              }
              {loading ? (
                <div className="item">
                  <Loader type="spinner-cub" bgColor={"#4168d1"} size={50} />
                </div>
              ) : (
                <tbody>
                  {returnsData.map((val, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span className='text-dark fw-bold text-hover-primary fs-6'>
                            {index + 1}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                            {val.name}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                            {val.tracking_id}&nbsp;&nbsp;
                            <i
                              onClick={() => {
                                setDetailsData(val);
                                setShowCreateAppModal2(true);
                              }} className="fa-solid fa-circle-info"></i>
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                            {val.commit_no}
                          </span>
                        </td>
                        <td>
                          {statusBody(val)}
                        </td>
                        <td className='text-dark fw-bold text-hover-primary fs-6'>
                          {val.date}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>
          </div>
          ) : (
            <div className="card">
              <div className="card-body px-0 py-1">
                <div className="mobile-card-container">
              {returnsData.length === 0 ? (
                <p className="p-text-center ms-5">You have no returns..</p>
              ) : (
                <div className="data-items">
                {
                  returnsData.map((item, idx) => (
                    <DataViewItem item={item} idx={idx}/>
                  ))
                }
              </div>
              )}
            </div>
              </div>
            </div>
          )}
        </div>
        {/*<div className='footer_btn3'>
          <button onClick={() => setShowCreateAppModal(true)}><i className="fa-solid fa-plus"></i>&nbsp; Add Returns</button>
        </div>*/}
      </div>
    </div>
  );
}

export default Returns;
